module.exports = __webpack_public_path__ + "img/JM.f4f7f5e1.png";